module.exports = __webpack_public_path__ + "img/13.efc544b2.jpg";